import styled from 'styled-components';

export const Wrapper = styled.div`
	padding: 20px;
`;

export const TableWrapper = styled.div`
	width: 100%;
`;
